<app-header></app-header>
<app-message-box title="Something went wrong" [url]="retryUrl">
  <p> Please try again.</p>
  <p *ngIf="errorMessage">{{errorMessage}}</p>
</app-message-box>
